import { Avatar, Box, Stack, Typography } from '@mui/material'
import { ComponentProps } from 'react'
import { useUser } from '../contexts/Auth/useUser'
import OptionsMenu from './OptionsMenu'

export const UserCard = (props: ComponentProps<typeof Stack>) => {
  const user = useUser()
  const $avatar = user ? (
    <Avatar
      sizes="small"
      src={user?.image || undefined}
      alt={`${user.givenName} ${user.familyName}`}
      sx={{ width: 36, height: 36 }}
    >
      {user?.givenName?.[0]}
      {user?.familyName?.[0]}
    </Avatar>
  ) : (
    <Avatar>?</Avatar>
  )
  return (
    <Stack
      direction="row"
      {...props}
      sx={{
        p: 2,
        gap: 1,
        alignItems: 'center',
        borderTop: '1px solid',
        borderColor: 'divider',
        ...props.sx,
      }}
    >
      {$avatar}
      <Box sx={{ mr: 'auto' }}>
        <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }}>
          {user?.givenName} {user?.familyName}
        </Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          {user?.email}
        </Typography>
      </Box>
      <OptionsMenu />
    </Stack>
  )
}
